<nav class="dot-nav-main">
  <div class="dot-nav" [hidden]="menu.length==0">
      <div [ngClass]="{'dimmed': dispatched}" (click)="toggleOpen($event)" title="Open Menu">
          <span ></span>
      </div>
      <ul [hidden]="!open">
        <!-- see interface ThreeDotsMenuItem description to know about This classes associated with keys -->
        <li *ngFor="let item of menu | sortByMenuOrder" 
            [ngClass]="{'really-remove': item.key === MENU_REALLY_REMOVE,
                        'confirmation-remove': itemMouseDown && item.key === MENU_REMOVE_WITH_CONFIRM }"
            (mousedown)="startClick(item.key, $event)"
            (mouseup)="endClick(item.key, $event)" 
            (click)="onClick(item.key, $event)"
            >
            <core-helpers-navigation-three-dots-menu-icon [icon]="item.icon"></core-helpers-navigation-three-dots-menu-icon>
            <span class="menu-title">{{item.title}}</span>
        </li>
      </ul>
  </div>
</nav>
